import { render, staticRenderFns } from "./confirmEmailChange.vue?vue&type=template&id=659c3a73&"
import script from "./confirmEmailChange.vue?vue&type=script&lang=js&"
export * from "./confirmEmailChange.vue?vue&type=script&lang=js&"
import style0 from "./confirmEmailChange.vue?vue&type=style&index=0&id=659c3a73&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports